import React, { useMemo } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { DynamicFormProps } from "@/modules/common/types";
import FormItemRenderer from "@/modules/lead-page/components/lead-info/edit-fields/status/forms/form-factory/form-field-renderer";
import FormFooter from "@/modules/lead-page/components/lead-info/edit-fields/status/forms/form-footer";
import Grid from "@mui/material/GridLegacy";

export const DynamicForm: React.FC<DynamicFormProps> = ({
  handleConfirm,
  onChange,
  formFields,
  isLoadingSubmition,
  disabledConfirmButton,
  handleClose,
  hideFooter,
}) => {
  const defaultValues = React.useMemo(() => {
    const values: Record<string, any> = {};
    formFields?.fields?.forEach((field) => {
      const fieldName = field.field.key || field.field.uid;

      if (field.field.defaultValue) {
        if (field.field.type === "dropdown") {
          const defaultValueOption = field.field.dropdowns.find(
            (option) => option.value === field.field.defaultValue
          );
          values[fieldName] = field.isMulti
            ? [
                {
                  label: defaultValueOption.label,
                  value: defaultValueOption.value,
                },
              ]
            : {
                label: defaultValueOption.label,
                value: defaultValueOption.value,
              };
        } else {
          values[fieldName] = field.field.defaultValue;
        }
      } else {
        values[fieldName] = field.isMulti ? [] : null;
      }
    });
    return values;
  }, [formFields]);

  const methods = useForm({
    defaultValues,
  });

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const onSubmit = (data: any) => {
    if (Object.keys(errors).length === 0) {
      handleConfirm?.(data, "form");
    }
  };

  const handleChange = (data: any) => {
    if (onChange) {
      onChange(data);
    }
  };

  const sortedFields = useMemo(
    () =>
      formFields?.fields?.sort(
        (a, b) =>
          new Date(a.createdAt || "").getTime() -
          new Date(b.createdAt || "").getTime()
      ),
    [formFields?.fields]
  );

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        onChange={handleSubmit(handleChange)}
      >
        <Grid container spacing={2} sx={{ paddingTop: "8px" }}>
          {sortedFields?.map((field) => (
            <React.Fragment key={field.id}>
              <FormItemRenderer
                field={field}
                control={control}
                watch={watch}
                setValue={setValue}
              />
            </React.Fragment>
          ))}

          {!hideFooter && (
            <FormFooter
              handleClose={handleClose ?? (() => {})}
              isLoadingSubmition={isLoadingSubmition || false}
              confirmText="Save"
              disabled={disabledConfirmButton}
            />
          )}
        </Grid>
      </form>
    </FormProvider>
  );
};
